import { Component,  OnInit, ViewChild,  ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { ApiService } from 'app/shared/services/api.service';
import { SessionStorageService } from 'app/shared/services/session-storage.service';
import { environment } from 'environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { DynamicDetailComponent } from '../../dynamic-detail/dynamic-detail.component';
import { Store } from '@ngrx/store';
import { AppState } from 'app/App Store/state';
import { setPageNumber } from 'app/App Store/actions/pageChange.actions';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-company-report',
  templateUrl: './company-report.component.html',
  styleUrls: ['./company-report.component.scss',
    "../../../../../../assets/sass/libs/datatables.scss",],
  encapsulation: ViewEncapsulation.None,
})
export class CompanyReportComponent implements OnInit {

 @ViewChild(DatatableComponent) table: DatatableComponent;
  page = {
    pageNumber:0,
    offset: 0,
    pageSize: 100,
    totalPages:0
  };
  // row data
  public rows = [];
  public filterRows=[];
  public ColumnMode = ColumnMode;
  public limitRef = 100;
  selectedValue=''
  isFilter:boolean=false
  // column header
  public columns = [
    { name: " Name", prop: "name" },
    { name: "Email", prop: "email" },
    { name: "Phone", prop: "phone" },
    { name: "Actions", prop: "actions" },
  ];

  // private
  private tempData = []; 
  imageUrl=environment.apiUrls.imageUrl;
  user_role: any
  type_List = []
  business_type_cat_id = '631ad8d1ce5c666542591bdd'
  activeTab: any
  contact_data = []
  row_name:any

  guideline_data:any
  pageNumberSubscription : Subscription

  constructor(public apiService:ApiService,
              public toastr: ToastrService,
              private modalService: NgbModal,
              private session: SessionStorageService,
              private activerouter: ActivatedRoute,
              private spinner: NgxSpinnerService,
              private route: Router, private store: Store<AppState> ) { 

                this.user_role = JSON.parse(localStorage.getItem('user'))
                let setting_data = JSON.parse(localStorage.getItem('setting-record'))
                let key_data = setting_data.filter((item) => item.key == 'Company Report') 
                this.guideline_data = key_data[0]?._id

                // this.getTypeList()

                this.activerouter.queryParamMap.subscribe((params) => {
                  let page = +params.get('page');
                  this.setPage(page)
                });
                this.pageNumberSubscription = this.store.select(state => state.page.pageNumber)
                .subscribe(pageNumber => {
                  this.page.pageNumber = pageNumber;
                  if(pageNumber !==undefined){
                    this.page.pageNumber = pageNumber ?  pageNumber-1 :0
                  }
                });

              }

  ngOnInit(): void {
    this.getBusinessList()
    // this.activeEmployeeTab('College')
  }
  // getTypeList() {
       
  //       this.apiService.getTagByTagCatgoryId(this.business_type_cat_id).subscribe((res: any) => {
  //         this.type_List = res.data
  //         this.setAndGetEmployeebyStatus()
  //       })
  // }
  //   activeEmployeeTab(tab) {
  //   const activetab = tab;
  //   this.activeTab = tab
  //   if (activetab !== '') {
  //     this.route.navigate(
  //       [],
  //       { relativeTo: this.activerouter, queryParams: { status: activetab } }
  //     );
  //   }
  // }
  // setAndGetEmployeebyStatus() {
  //   this.activerouter.queryParams
  //     .subscribe((params: any) => {
  //       this.activeTab = params?.status;
  //      this.getBusinessList()
  //     })
  // }

setPage(pageNumber: number) {
    this.store.dispatch(setPageNumber({ pageNumber }));
  }

  getBusinessList() {
     this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    // let status = this.type_List.find((item) => item.name == this.activeTab);
    this.apiService.getBusinessByTypeId('6325ce10bc4b543c7a2429ad').subscribe((res: any) => {
      this.spinner.hide()
      this.rows = res?.data
      this.page.totalPages=res.data.length
    })
  }
  pageChangeData(page:any) {
    // this.route.navigate([], {
    //   relativeTo: this.activerouter,
    //   queryParams: { page: page.offset +1 },
    //   queryParamsHandling: 'merge' // keep existing query params
    // });
    // this.apiService.getContactList(page.offset +1,page.pageSize).subscribe((res:any)=>{
    //   this.setPage(page.offset +1)
    //   this.rows =res.data.items
    //   this.page.totalPages=res.data.totalCount
    // }) 
  }
  getContactFilter(event:any){
    let search=event.target.value
    if(search){
      this.apiService.contactSearch(search).subscribe((res:any)=>{
        this.rows =res.data
      })
    }
    else{
      // this.getContactList()
    }
  }
  getContactByBusId(id) {
    if(id){
      this.apiService.getContactByBusinessId(id).subscribe((res: any) => {
        this.contact_data =res.data
      })
    }
  }
  openModalUpdate(content, id,name) {
    this.row_name =name
    this.getContactByBusId(id)
    const modalOptions: NgbModalOptions = {
      size: 'lg' // 'sm', 'lg', or 'xl'
    };
      const modalRef = this.modalService.open(content,modalOptions);
      
      modalRef.result.then((result) => {
        // console.log(`Modal closed with result: ${result}`);
      }, (reason) => {
        // console.log(`Modal dismissed with reason: ${reason}`);
      });
  }
  openDynamicModal(key_id:string) {
    const modalOptions: NgbModalOptions = {
      size: 'lg', // 'sm', 'lg', or 'xl'
      backdrop: 'static',
    };
    const modalRef = this.modalService.open(DynamicDetailComponent,modalOptions);
    modalRef.componentInstance.key_id = key_id;
  }
  

}
